var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "h2",
    {
      staticClass: "boss-title-setting",
      attrs: { "data-test": "header-title" },
    },
    [
      _c("breadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } }),
      _vm._v("\n  " + _vm._s(_vm.title) + "\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }